import { Component, OnInit, AfterViewInit, Input, Output, TemplateRef, ElementRef, ViewChild } from "@angular/core";
import { Router, ActivationEnd } from '@angular/router';
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from "@angular/common/http";
declare var jQuery: any;
import { WeatherModel } from "src/app/interfaces/weather.model";
import { WeatherService } from "src/app/services/weather.service";
import { LocationService } from "src/app/services/location.service";
import { SideNavService } from "src/app/services/sidenav.service";
import { UnlServiceService } from "src/app/services/unl-service.service";
import { CurrentMenuStateService } from "src/app/services/current-menu-state.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-fixed-content",
  templateUrl: "./fixed-content.component.html",
  styleUrls: ["./fixed-content.component.scss"]
})
export class FixedContentComponent implements OnInit {
  environmentType = environment.environmentType;
  //for header
  @ViewChild('redirect') redirectTemplate: ElementRef;
  @ViewChild('closeMenu') closeMenuButton: ElementRef;
  @ViewChild('loginSignup') loginSignupTemplate: TemplateRef<any>;

  myWeather: WeatherModel = new WeatherModel("", "", "", "", "", "");
  location;
  selectedOption ='';
  rmi;
  selectvps;
  termId;
  modalRef: BsModalRef;
  redirectDesc: string;
  _opened = false;
  animate = false;
  toggle =false;
  parentwidth;
  // for select location popup
  closeResult: string;
  data_JSON: any;
  data_State: any;
  data_City: any;
  data_Country: any;
  dialcodeJson = [];
  countryCode: any;
  i = 0;
  stateId;
  cityId;
  countryId = "all";
  ctype = "all";
  termidJson: Object;
  math = Math;
  addonlink;
  newMenu = 'ALL';
  isModalOpen: boolean;
  setloactiondetails(ispopup) {
    if(this.termidJson !== undefined){
    var termData = this.termidJson[0].termlist;
    termData = JSON.parse(termData);
    if (termData.length === 1) {

      var ctName = termData[0].name;
      var ctid = termData[0].tid;
      this.countryId = ctid;
      this.termId = ctid

      this.selectedOption = ctName;
      this.http.get("assets/dialingcode.json").subscribe(
        val => {
          //  this.dialcodeJson = val
          this.dialcodeJson = Object.entries(val).map(([type, value]) => ({ type, value }));


          for (let i = 0; i < this.dialcodeJson.length; i++) {


            var cName = this.dialcodeJson[i].value.name;

            if (cName == ctName) {
              this.countryCode = this.dialcodeJson[i].value.code

              break;
            }
            else {

            }
          }
        })
    }
    else if (termData.length === 2) {
      var stName = termData[0].name;
      var ctName = termData[1].name;
      this.stateId = termData[0].tid;
      this.countryId = termData[1].tid;
      this.termId = termData[0].tid;
      if (ispopup)
        this.setStateOnly();
      if (stName === "All States") {
        this.selectedOption = "All cities";
      }
      else {
        this.selectedOption = stName;
      }
      this.http.get("assets/dialingcode.json").subscribe(
        val => {
          //  this.dialcodeJson = val
          this.dialcodeJson = Object.entries(val).map(([type, value]) => ({ type, value }));
          for (let i = 0; i < this.dialcodeJson.length; i++) {
            var cName = this.dialcodeJson[i].value.name;
            if (cName == ctName) {
              this.countryCode = this.dialcodeJson[i].value.code
              break;
            }
            else {
            }
          }
        })
    }
    else if (termData.length === 3) {
      var ctyName = termData[0].name;
      var stName = termData[1].name;
      var ctName = termData[2].name;
      this.termId = termData[0].tid
      this.cityId = termData[0].tid;
      this.stateId = termData[1].tid;
      this.countryId = termData[2].tid;
      if (ispopup)
        this.setStateAndCity();

      if (ctyName === "All Cities") {
        this.selectedOption = stName;
      }
      else {
        this.selectedOption = ctyName;
      }
      this.http.get("assets/dialingcode.json").subscribe(
        val => {
          //  this.dialcodeJson = val
          this.dialcodeJson = Object.entries(val).map(([type, value]) => ({ type, value }));

          for (let i = 0; i < this.dialcodeJson.length; i++) {

            var cName = this.dialcodeJson[i].value.name;

            if (cName == ctName) {
              this.countryCode = this.dialcodeJson[i].value.code

              break;
            }
            else {

            }
          }
        })
    }
  }
  }
  constructor(
    private router: Router,
    private weatherService: WeatherService,
    private sideNavService: SideNavService,
    public locationService: LocationService,
    public unlService: UnlServiceService,
    private unlServiceService: UnlServiceService,
    private modalService: BsModalService,
    private currentMenuStateService: CurrentMenuStateService,
    private modalpopService: NgbModal,
    private http: HttpClient,
  ) {
    this.router.events.subscribe((event) => {
      
      if (event instanceof ActivationEnd && event.snapshot.params.ctype) {
        var addonlink ='';
        var currlink = window.location.pathname.split('/');
        var i =0;
        currlink.forEach(function (value) {
          if(i>3)
            addonlink =addonlink +'/'+ value ;
          i++;
        }); 
        this.addonlink = addonlink;
        var ctype = event.snapshot.params.ctype;
        if (ctype === undefined) {
          this.ctype = "all"
        }
        this.ctype = ctype;
        var cIndex = this.unlServiceService.getIndexBycType(ctype);
        let item = this.unlServiceService.menus[cIndex];
        this.rightMenuEvent(item, cIndex, false);
        var termID = this.termId = event.snapshot.params.termid;
        if (termID !== undefined) {
          if (termID !== "all") {
            this.http.get(this.unlService.getTermID(termID)).subscribe(
              val => {
                this.termidJson = val;
                this.setloactiondetails(false);
              });
          } 
          else {
            this.selectedOption = "All countries"
          }
        }
      }


    });
  }

  setStateOnly() {
    this.locationService.allStates(this.countryId).subscribe(
      data_State => {
        let stateArray = [];
        for (let i = 0; i < data_State.length; i++) {
          var cData = data_State[i];
          var cName = cData.term;
          if (cName.toLowerCase() === "all states") {
            stateArray.splice(0, 0, cData);
          } else {
            stateArray.push(cData);
          }
        }

        this.data_State = stateArray;

      },


    );
  }
  setStateAndCity() {
    this.locationService.allStates(this.countryId).subscribe(
      data_State => {
        let stateArray = [];
        for (let i = 0; i < data_State.length; i++) {
          var cData = data_State[i];
          var cName = cData.term;
          if (cName.toLowerCase() === "all states") {
            stateArray.splice(0, 0, cData);
          } else {
            stateArray.push(cData);
          }
        }

        this.data_State = stateArray;

      },
   
 
    );
    this.locationService.allCity(this.stateId).subscribe(
      data_City => {
        let cityArray = [];
        for (let i = 0; i < data_City.length; i++) {
          var cData = data_City[i];
          var cName = cData.term;
          if (cName.toLowerCase() === "all cities") {
            cityArray.splice(0, 0, cData);
          } else {
            cityArray.push(cData);
          }
        }

        this.data_City = cityArray;


      },




    );
  }
  _test() {
    this.selectedOption = this.locationService.getData();
  }
  _varSet(){
    
  }
  openModal(msg: string) {
    this.modalService.config.backdrop = true;
    this.redirectDesc = msg;
    this.modalRef = this.modalService.show(this.redirectTemplate, { class: "modal-sm redirectalign" });
  }
  classInactive(){
    var active = undefined;
    this.leftMenuEvent(active );
  }
  ngOnInit() {
  //   setTimeout(function() {
  //     $('.loader').fadeOut('fast');
  //     $('.loader2').show('fast')
  // }, 2000);
    // this.ctype = "all"

    
    this.getCountries();
    this._opened = false;
    this.toggle = false;
    
    if (window.navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        pos => {
          this.location = pos.coords;
          const lat = this.location.latitude;
          const lon = this.location.longitude;
          this.weatherService.localWeather(lat, lon).subscribe((data: any) => {
            this.myWeather = new WeatherModel(
              data.name,
              Math.round(data.main.temp) + "\xB0" + "C",
              "https://openweathermap.org/img/w/" +
              data.weather[0].icon +
              ".png",
              data.weather[0].description,
              "Min: " + data.main.temp_min + "9\xB0" + "F",
              "Max: " + data.main.temp_max + "9\xB0" + "F"
            );
          });
        },
        error => {

          this.weatherService.getIpAddress().subscribe(data1 => {
            var lat = data1["latitude"];
            var lon = data1["longitude"];
            this.weatherService
              .localWeather(lat, lon)
              .subscribe((data: any) => {
                this.myWeather = new WeatherModel(
                  data.name,
                  Math.round(data.main.temp) + "\xB0" + "C",
                  "http://openweathermap.org/img/w/" +
                  data.weather[0].icon +
                  ".png",
                  data.weather[0].description,
                  "Min: " + data.main.temp_min + "9\xB0" + "F",
                  "Max: " + data.main.temp_max + "9\xB0" + "F"
                );
              });
          });
        }
      );
    }
    
  }
  ngAfterViewInit() {
    this.parentwidth = $(".scroll").width();
    this.unlServiceService.getWidth(this.parentwidth);
    jQuery.fancybox.defaults.infobar = false;
  }
   openmdl(){
    // jQuery.fancybox.defaults.modal = true;
    // jQuery.fancybox.defaults.mobile.preventCaptionOverlap = true;
    jQuery.fancybox.defaults.hash = "selectlocation";
    jQuery.fancybox.defaults.infobar = false;
    jQuery.fancybox.defaults.caption = '';
    this.setloactiondetails(true);
    // jQuery( "div" ).removeClass( "fancybox-infobar" );
    // jQuery("[data-fancybox]").fancybox({
    //   hash : ,
    //   caption : '',
      
    // });
  }
  //for rightsidenav
 
  public _togglerightSidebar() {
    this.animate = true;
    this._opened = !this._opened;
    this.toggle = !this.toggle;
      // Get the child div with id="ok"
  const childDiv = document.querySelector('#');

  var element = document.querySelector('.ng-sidebar__content.ng-sidebar__content--animate') as HTMLElement;;

  // Check if the element exists before applying styles (optional but recommended)
  if (element) {
      element.style.transform = 'translateX(0px) !important';
  }
  }

  triggerButtonClick() {
    // Triggering button click programmatically
    if (this._opened) {
      this.closeMenuButton.nativeElement.click();
    }
  }

  toggleMenu(value: string): void {
    this._togglerightSidebar()
  }

  rightMenuEventFromChild(event: any) {
    this.rightMenuEvent(event.rMenu,event.rmi,true)
  }

  rightMenuCls: string = "inactive";
  public rightmenuCurrent = this.unlService.menus[0];
  rightMenuEvent(item, rmi, isOpen) {
    console.log(item);
    this.updateMenu(item.title)
    this.rmi = rmi;
    $(".searchcss form").removeClass('open');
    this.locationService.rmindex(rmi, item);
    if (isOpen) {
      this._togglerightSidebar();
      this.triggerButtonClick();
    }
    if(rmi==8){
      this.leftMenuEvent(this.leftMenuDetails[1]);
    }else if(rmi ==9){
      this.leftMenuEvent(this.leftMenuDetails[2]);
    }else{
      var active = undefined;
      this.leftMenuEvent(active);
    }
    // this._test();
    this.rightmenuCurrent = item;
    this.rightMenuCls =
      this.rightMenuCls === "inactive" ? "active" : "inactive";

  }
  getCurrentSrc1(rMenu) {
    return rMenu.icon;
  }
  setrightActive(item) {
    return this.rightmenuCurrent === item;
  }

  //for Sidenav

  public scrollbarOptions = { axis: "y", theme: "minimal-dark" };
  leftmenuCurrent;
  leftMenuDetails = [
    {
      text: "LOGIN",
      normalimg: "assets/login_normal.png",
      selectimg: "assets/login_sel.png"
    },
    {
      text: "VIDEOS",
      normalimg: "assets/video_nor.png",
      selectimg: "assets/video_sel.png",
      link:"videos"
    },
    {
      text: "PHOTOS",
      normalimg: "assets/images_nor.png",
      selectimg: "assets/images_sel.png",
      link:"photos"
    },
    {
      text: "FRIENDS",
      normalimg: "assets/friends_nor.png",
      selectimg: "assets/friends_sel.png"
    },
    {
      text: "MINGLE",
      normalimg: "assets/mingle_white.png",
      selectimg: "assets/mingle_blue.png"
    },
    {
      text: "FLIRT",
      normalimg: "assets/flirt_white.png",
      selectimg: "assets/flirt_blue.png"
    },
    {
      text: "BUSINESS",
      normalimg: "assets/network_white.png",
      selectimg: "assets/network_blue.png"
    },
    {
      text: "FOLLOW",
      normalimg: "assets/follow_white.png",
      selectimg: "assets/follow_blue.png"
    },
    {
      text: "FAVORITES",
      normalimg: "assets/fav_nor.png",
      selectimg: "assets/fav_sel.png"
    }
  ].filter(x  => environment.environmentType === 'h' ? (x.text !== 'MINGLE' && x.text !== 'FLIRT') : x);
  leftMenuCls: string = "inactive";
  leftMenuEvent(item) {
    this.leftmenuCurrent = item;

 

    if(item !== undefined){
      let cText: string = this.leftmenuCurrent.text.toLowerCase();
   
      if(cText !== 'login' && cText !== 'mingle' && cText !== 'friends' && cText !== 'bussines'
         && cText !== 'favorites'
         && cText !== 'follow')  {
          this.leftMenuCls = this.leftMenuCls === "inactive" ? "active" : "inactive";
      }
      if (cText === "videos" || cText === "photos") {

      } else {
        this.openModal1(this.loginSignupTemplate);
        this.isModalOpen = true;
        this.leftMenuCls = "inactive";
      }
    }
   
  }
  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm modalsizecls' });
  }
  
  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }
  getCurrentSrc(lMenu) {
    return lMenu.normalimg;
  }
  setleftActive(item) {
    if(item !== undefined){
      return this.leftmenuCurrent === item;
    }else{
      return this.leftmenuCurrent === undefined;
    }
  }

  //test
  vpsclick(selectvps) {
    this.selectvps = selectvps;
  }
  //  for select location popup
  open(location) {
    this.setloactiondetails(true);
    this.modalpopService.open(location, { ariaLabelledBy: 'modal-basic-title', windowClass: "locationpopup" }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // for select location
  onCountrySelect($event) {
    this.i = $event.target.options.selectedIndex;
    this.locationService.setSelectedCountry(this.i);
  }
  changeLocation($event, coutrysbox, statesbox, citysbox): any {
    try {
      var selectedText1 = coutrysbox[coutrysbox.selectedIndex].innerHTML;
      var selectedText2, selectedText3;
      if (statesbox[statesbox.selectedIndex] !== undefined) {
        selectedText2 = statesbox[statesbox.selectedIndex].innerHTML;
      }
      if (citysbox[citysbox.selectedIndex] !== undefined) {
        selectedText3 = citysbox[citysbox.selectedIndex].innerHTML;
      }

      //  this.selectedOption=selectedText3;
      console.log("Selected Country", selectedText1);
      console.log("Selected State", selectedText2);
      console.log("Selected City", selectedText3);
      // this.getDialcode();
      this.http.get("assets/dialingcode.json").subscribe(
        val => {
          //  this.dialcodeJson = val
          this.dialcodeJson = Object.entries(val).map(([type, value]) => ({ type, value }));

          for (let i = 0; i < this.dialcodeJson.length; i++) {

            var cName = this.dialcodeJson[i].value.name;
            if (cName == selectedText1) {
              this.countryCode = this.dialcodeJson[i].value.code

              break;
            }
            else {

            }
          }
        });
      if ((selectedText3 === undefined) && (selectedText2 === undefined) && (selectedText1 === "All countries")) {
        this.selectedOption = "All countries";
        this.countryCode = "all";
      }
      else if ((selectedText3 === undefined || selectedText3 === "All Cities") && (selectedText2 !== undefined && selectedText2 !== "All States")) {
        this.selectedOption = selectedText2
      }
      else if ((selectedText3 === undefined || selectedText3 === "All Cities") && (selectedText2 === undefined || selectedText2 === "All States")) {
        this.selectedOption = "All cities"
      }
      else if ((selectedText3 !== undefined || selectedText3 !== "All Cities") && (selectedText2 !== undefined && selectedText2 !== "All States")) {
        this.selectedOption = selectedText3
      } 

    } catch (e) {

    }
 //this.dynamic.onOurInit();
  }

  getCountries() {
    this.locationService.allCountries().subscribe(
      data_JSON => {
        var cdat = { "term": "All countries", "term id": "all" };
        if(data_JSON[0].term !="All countries")
          data_JSON.splice(0, 0, cdat);
        this.data_Country = data_JSON;
        this.setloactiondetails(true);
        //this.selectedOption = this.data_Country[0].term;
        var termFirst = this.data_Country[0];
        if(this.termId ==undefined)
          this.termId = termFirst['term id'];
        if(this.ctype ==undefined)
          this.ctype = "all";
      }
    );
  }

  onChangeCountry(countValue, coutrysbox) {
    // var selectedText1 = coutrysbox[coutrysbox.selectedIndex].innerHTML;
    this.data_State = [];
    this.data_City = [];
    this.stateId = undefined;
    this.cityId = undefined;
    if (countValue !== "all") {
      this.locationService.allStates(countValue).subscribe(
        data_State => {
          let stateArray = [];
          for (let i = 0; i < data_State.length; i++) {
            var cData = data_State[i];
            var cName = cData.term;
            if (cName.toLowerCase() === "all states") {
              stateArray.splice(0, 0, cData);
            } else {
              stateArray.push(cData);
            }
          }

          this.data_State = stateArray;
          this.stateId = this.data_State[0]["term id"];
        },

      );
    }

  }

  onChangeState(stateValue) {
    this.data_City = [];
    this.cityId = undefined;
    this.locationService.allCity(stateValue).subscribe(
      data_City => {
        let cityArray = [];
        for (let i = 0; i < data_City.length; i++) {
          var cData = data_City[i];
          var cName = cData.term;
          if (cName.toLowerCase() === "all cities") {
            cityArray.splice(0, 0, cData);
          } else {
            cityArray.push(cData);
          }
        }

        this.data_City = cityArray;
        this.cityId = this.data_City[0]["term id"];
      },

    );
  }


  updateMenu(newMenu: string) {
    this.currentMenuStateService.updateCurrentState({ menu: newMenu });
    if(this.newMenu != newMenu) {
      localStorage.setItem("scrollPosition",'0')
     $(".ng-sidebar__content").scrollTop(0);
   }
   this.newMenu = newMenu;
  }
 

}
